export const FIXED_SERVICE_CATEGORIES = ['DSL', 'FTTH', 'LITE TV', 'SAT TV'];
export const EMPLOYEE_SERVICE_CATEGORY = 'EMPLOYEE';
export const BILLING_TYPE_PREPAID = 'PREPAID';

export const STATUS_CODE_SUSPENDED = '50';
export const STATUS_CODE_SWITCHED_OFF = '60';
export const STATUS_CODE_DISCONNECT = '70';
export const UNSERVICEABLE_STATUS_CODES = [
  STATUS_CODE_SUSPENDED,
  STATUS_CODE_SWITCHED_OFF,
  STATUS_CODE_DISCONNECT,
];

export const ECARE_UNSUPPORTED_B2B_BUSINESS_TYPES = [
  'B2B_A',
  'B2B_B',
  'B2B_C',
  'B2B_D',
  'B2B_I',
  'B2B_P',
  'B2B_S',
  'LA',
  'LA_I',
  'SME_A',
  'SME_B',
  'SME_C',
  'SME_I',
  'SOHOA',
];
